import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const ReplyIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 17"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M6.9416 0.545326L0.771289 6.71564M0.771289 6.71564L6.9416 12.886M0.771289 6.71564H13.1119C15.3838 6.71564 17.2255 8.55734 17.2255 10.8292V17" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
  </Svg>
);

ReplyIcon.displayName = 'ReplyIcon';
